import { action } from 'easy-peasy';
import { IActionSetClient } from '../types';

const setClient: IActionSetClient = action((state, payload) => {
  state.current = payload;
});

export default setClient;
